import React from 'react';
import block from 'bem-cn-lite';
import {HTML} from '@doc-tools/components';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

import {CalculatorProps} from 'components/calculator/models';

import './CalculatorForm.scss';

const b = block('CalculatorForm');

interface CalculatorFormProps extends ClassNameProps, Pick<CalculatorProps, 'title'> {}

function CalculatorForm(props: React.PropsWithChildren<CalculatorFormProps>) {
    const {title, children, className} = props;

    return (
        <div className={b(null, className)}>
            <h5 className={b('title')}>
                <HTML>{title}</HTML>
            </h5>
            <div className={b('content')}>{children}</div>
        </div>
    );
}

export default CalculatorForm;
